import React, { useState } from "react";
import MetaTags from "./components/MetaTags";
import AppBar from "./components/AppBar";
import Footer from "./components/Footer";
import { Container, Row, Col } from "react-bootstrap";
import { PiMapPinSimpleAreaBold } from "react-icons/pi";
import { BiPhoneCall } from "react-icons/bi";
import { MdOutlineAlternateEmail } from "react-icons/md";
import { FaQrcode, FaCopy, FaCheck } from "react-icons/fa";
import { SiGooglepay } from "react-icons/si";

const ContactUs = () => {
  const [copied, setCopied] = useState(false);
  const upiId = "rakeshmahesh2010-1@okaxis";

  const handleCopy = () => {
    navigator.clipboard.writeText(upiId);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      <MetaTags
        title="Contact Us - GMR Crackers - Wholesale Crackers Sivakasi"
        type="website"
        siteName="gmrcrackers.com"
        url="https://gmrcrackers.com/contactus"
        keywords="Contact Us | GMR Crackers | Sivakasi Crackers"
        description="Contact GMR Crackers for wholesale and retail crackers inquiries directly from Sivakasi."
        revisitAfter="10 Days"
      />
      <AppBar />
      <img
        src={require("../assets/images/banner/banner_elevel.jpg")}
        className="img-fluid w-100"
        alt="Contact GMR Crackers"
      />
      
      <div className="padding bg-white">
        <Container>
          <Row>
            <Col xs={12} className="text-center pb-4">
              <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-1 rounded-pill bold text-uppercase mb-2">
                Get in Touch
              </span>
              <h1 className="bold text-center lg-font text-dark mt-2 mb-2">
                Contact GMR Crackers
              </h1>
              <p className="text-muted bold fs-5 mx-auto" style={{ maxWidth: "600px" }}>
                Reach out to our Sivakasi sales and support team for quick enquiries, custom gift boxes, or bulk bookings.
              </p>
            </Col>

            {/* Address Box */}
            <Col lg="4" md="6" className="py-2">
              <div className="box h-100 bg-light rounded-4 border p-4 shadow-sm text-center">
                <div className="box-icon bg-danger text-white rounded-circle p-3 d-inline-flex mb-3 shadow">
                  <PiMapPinSimpleAreaBold size={36} color="#fff" />
                </div>
                <h4 className="bold text-dark mb-2">Factory Location</h4>
                <div className="regular text-muted small lh-base">
                  D. No: 3/347c1/1, Maraneri, Sivakasi to Alangulam Main Road, Singampatti, Sivakasi, Tamil Nadu - 626124
                </div>
              </div>
            </Col>

            {/* Phone Box */}
            <Col lg="4" md="6" className="py-2">
              <div className="box h-100 bg-light rounded-4 border p-4 shadow-sm text-center">
                <div className="box-icon bg-success text-white rounded-circle p-3 d-inline-flex mb-3 shadow">
                  <BiPhoneCall size={36} color="#fff" />
                </div>
                <h4 className="bold text-dark mb-2">Phone & WhatsApp</h4>
                <div className="regular d-flex flex-column gap-2 mt-2">
                  <a href="tel:+919843058048" className="bold text-decoration-none text-dark fs-6 hover-danger">
                    +91 98430 58048 (WhatsApp)
                  </a>
                  <a href="tel:+917358866226" className="regular text-decoration-none text-muted small hover-danger">
                    +91 73588 66226
                  </a>
                  <a href="tel:+919976858631" className="regular text-decoration-none text-muted small hover-danger">
                    +91 99768 58631
                  </a>
                </div>
              </div>
            </Col>

            {/* Email Box */}
            <Col lg="4" md="12" className="py-2">
              <div className="box h-100 bg-light rounded-4 border p-4 shadow-sm text-center">
                <div className="box-icon bg-primary text-white rounded-circle p-3 d-inline-flex mb-3 shadow">
                  <MdOutlineAlternateEmail size={36} color="#fff" />
                </div>
                <h4 className="bold text-dark mb-2">Email Enquiry</h4>
                <p className="regular text-muted small mb-2">Send us your requirement list anytime</p>
                <a href="mailto:gmrcrackers@gmail.com" className="bold text-primary text-decoration-none fs-6">
                  gmrcrackers@gmail.com
                </a>
              </div>
            </Col>

            {/* Google Pay / UPI Details Box */}
            <Col lg="12" className="py-4">
              <div className="p-4 bg-light rounded-4 border shadow-sm">
                <Row className="align-items-center">
                  <Col lg="4" className="text-center py-2">
                    <div className="p-2 bg-white rounded-3 border d-inline-block shadow-sm" style={{ width: "100%", maxWidth: "230px" }}>
                      <img
                        src={require("../assets/images/gpay_qr.jpg")}
                        alt="GMR Crackers Google Pay QR"
                        className="img-fluid rounded"
                        style={{ width: "100%", height: "auto", objectFit: "contain", display: "block" }}
                      />
                    </div>
                  </Col>
                  <Col lg="8" className="py-2">
                    <span className="badge bg-danger bold px-3 py-1 rounded-pill mb-2">
                      <SiGooglepay size={18} /> Official Payment Info
                    </span>
                    <h3 className="bold text-dark mb-2">Pay Directly via Google Pay or UPI</h3>
                    <p className="regular text-muted mb-3">
                      Scan the QR code with any UPI app (Google Pay, PhonePe, Paytm, or BHIM) to make instant advance or order payments.
                    </p>
                    <div className="d-flex flex-wrap align-items-center gap-3">
                      <div className="p-2 bg-white rounded-3 border">
                        <span className="small text-muted d-block" style={{ fontSize: "11px" }}>UPI ID:</span>
                        <strong className="bold text-danger fs-6">{upiId}</strong>
                      </div>
                      <button
                        onClick={handleCopy}
                        className={`btn ${copied ? "btn-success" : "btn-primary"} bold px-4 py-2 rounded-pill`}
                      >
                        {copied ? <><FaCheck /> Copied to Clipboard!</> : <><FaCopy /> Copy UPI ID</>}
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            {/* Google Map */}
            <Col lg="12" md="12" xs="12" className="py-3">
              <div className="rounded-4 overflow-hidden shadow border">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2998.130460754715!2d77.7379928750237!3d9.420772990657083!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zOcKwMjUnMTQuOCJOIDc3wrA0NCcyNi4wIkU!5e1!3m2!1sen!2sin!4v1757161176622!5m2!1sen!2sin"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen
                  title="Google Maps Location of GMR Crackers Sivakasi"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </div>
  );
};

export default ContactUs;

